module.exports = __webpack_public_path__ + "static/Vazir-Medium-7d4b4c27eb13cb5c02ed8005a8fe1809.ttf";